export default __webpack_public_path__ + "static/media/Belt of Vindictive Malice.846c88ba.jpg";